import { Component, OnInit, ViewChild } from '@angular/core';
import { OnDemandEmailService } from 'src/app/services/on-demand-email.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatLegacyChipInputEvent as MatChipInputEvent, MatLegacyChipList as MatChipList } from '@angular/material/legacy-chips';
import { AwsSqsService } from '../../../services/aws-sqs.service';
import { ApiService } from 'src/app/services/api.service';
import * as Constants from '../../../models/Constants';

@Component({
  selector: 'app-on-demand-email',
  templateUrl: './on-demand-email.component.html',
  styleUrls: ['./on-demand-email.component.scss']
})

export class OnDemandEmailComponent implements OnInit {
  emails: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA]; // Use Enter and Comma to separate emails
  emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Stricter email regex
  removable: boolean = true
  invalidEmails: string[] = [];
  @ViewChild('chipList') chipList!: MatChipList;

  filteredData: any;
  autoPopulatedEmail = '';
  constructor(public rootScopeService: RootScopeService, public awsSQSService: AwsSqsService,
    public onDemandEmailService: OnDemandEmailService, public apiService: ApiService) { }

  /* istanbul ignore next */
  ngOnInit(): void {
    this.rootScopeService.activeCustTab.onDemandEmailData.sentEmailSuccess = false;
    this.rootScopeService.activeCustTab.onDemandEmailData.sendEmailFailed = false;

    this.onDemandEmailService.createOnDemandEmailForm();
    this.onDemandEmailService.getOnDemandEmailConfig();
    this.onDemandEmailService.retainOnDemandEmailDataForTabChange();
    setTimeout(() => {
      // Restore emails on component load
      const storedEmails = this.rootScopeService.activeCustTab.onDemandEmailData.emailId || '';
      if (storedEmails) {
        this.restoreEmails(storedEmails);
      }
    }, 500);
    this.updateFormValidity();
  }

  restoreEmails(storedEmails: string): void {
    const emailArray = storedEmails.split(',');
    emailArray.forEach((email: string) => {
      if (this.isValidEmail(email)) {
        if (!this.emails.includes(email)) {
          this.emails.push(email);
        }
      } else {
        if (!this.invalidEmails.includes(email)) {
          this.invalidEmails.push(email);
        }
      }
    });

    this.validateEmails();
    this.updateFormValidity();
  }

  /**Below method called when the user select the Template from the On-Demand email page and auto-filled */
  onTemplateSelection(event: any) {
    const templateName = this.onDemandEmailService.onDemandForm?.get('template')?.value;
    const emailTemplateList = this.rootScopeService.activeCustTab.onDemandEmailData?.emailTemplateList;

    if (templateName) {
      this.filteredData = emailTemplateList.find(x => x?.name == templateName);
      this.rootScopeService.activeCustTab.onDemandEmailData.selectedTemplateList = this.filteredData;
      this.onDemandEmailService.onDemandForm.get('title')?.setValue(this.filteredData?.subject);
      this.onDemandEmailService.onDemandForm.get('description')?.setValue(this.filteredData?.body);

    }


  }


  sendEmailButtonClicked(): void {
    let begin = new Date().toISOString();
    let selectedTemplateListData = this.rootScopeService?.activeCustTab?.onDemandEmailData?.selectedTemplateList;
    if (this.onDemandEmailService.onDemandForm.valid) {
      const allEmails = this.rootScopeService.activeCustTab.onDemandEmailData.emailId.split(',');
      // Filter out only valid emails
      const validEmails = allEmails.filter(email => this.isValidEmail(email.trim()));
      if (validEmails.length > 0) {
        let sendEmailObj = {
          "template": this.onDemandEmailService?.onDemandForm?.get('template')?.value,
          "emailId": validEmails.join(', '),
          "subject": selectedTemplateListData?.subject,
          "body": selectedTemplateListData?.body,
          "clientId": this.rootScopeService.activeCustTab.clientId,
          "attachmentIds": selectedTemplateListData?.attachmentid,
          "senderEmailId": selectedTemplateListData?.senderEmailId
        };

        this.apiService.sendEmail(sendEmailObj).subscribe({
          next: (data?: any) => {
            if (data?.httpStatusCode == 200) {
              this.rootScopeService.activeCustTab.onDemandEmailData.sentEmailSuccess = true;
              this.rootScopeService.enableAlerts(Constants.SUCCESS, Constants.ONDEMAND_EMAIL_SUCCESS);
              this.sendOnDemandEmailDataInIH(begin);
              this.clearForm();
            }
          },
          error: (err) => {
            this.rootScopeService.activeCustTab.onDemandEmailData.sendEmailFailed = true;
            this.rootScopeService.enableAlerts(Constants.ERROR, Constants.ONDEMAND_EMAIL_FAIL);
          }
        });
      } else {
        console.log('No valid emails to send.');
      }

    } else {
      // Log invalid form state if the form is not valid
      console.log('Form is invalid.');
    }
  }


  /**
   * Story no  :- CCR1-6671.
   */
  /* istanbul ignore next */
  sendOnDemandEmailDataInIH(begin) {
    let onDemandEmailIHObj = this.onDemandEmailService.createOnDemandEmailIH(begin);
    this.awsSQSService.sendInteractionHistoryToSQS(onDemandEmailIHObj);
  }

  /**Below method Clear the On-DemandEmail Form */
  clearForm(): void {
    this.rootScopeService.activeCustTab.onDemandEmailData.selectedTemplateList = {};
    this.rootScopeService.activeCustTab.onDemandEmailData.emailId = '';
    this.onDemandEmailService.onDemandForm.reset();
    this.emails = [];
    this.invalidEmails = [];
  }

  /**Below method validate email format and required field and return the error message */
  getEmailErrorMessage(): string {
    const emailControl = this.onDemandEmailService.onDemandForm.get('email');
    if (emailControl?.hasError('required')) {
      return 'Email is required';
    }

    if (this.invalidEmails.length > 0) {
      return `Invalid emails: ${this.invalidEmails.join(', ')}`;
    }
    return '';
  }


  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = (event.value || '').trim();

    if (value) {
      if (this.isValidEmail(value)) {
        this.emails.push(value);
      } else {
        this.invalidEmails.push(value);
      }

      this.validateEmails();
      this.updateFormValidity();
      this.storeEmails();
    }

    if (input) {
      input.value = '';
    }
  }

  remove(email: string): void {
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails.splice(index, 1);
    }
    const invalidIndex = this.invalidEmails.indexOf(email);
    if (invalidIndex >= 0) {
      this.invalidEmails.splice(invalidIndex, 1);
    }
    this.validateEmails();
    this.updateFormValidity();
    this.storeEmails();
  }

  updateFormValidity() {

    const hasInvalidEmails = this.invalidEmails.length > 0;
    this.onDemandEmailService.onDemandForm.get('email')?.setErrors(hasInvalidEmails ? { invalidEmails: true } : null);
    const isFormValid = this.emails.length > 0 && !hasInvalidEmails;
    if (isFormValid) {
      this.onDemandEmailService.onDemandForm.get('email')?.setErrors(null);
    }
    let emailControl = this.onDemandEmailService.onDemandForm.get('email');

    if (this.emails.length === 0 && this.invalidEmails.length === 0) {
      emailControl?.setErrors({ required: true });
    }
    else if (this.invalidEmails.length > 0) {
      emailControl?.setErrors({ invalidEmails: true });
    }

    this.onDemandEmailService.onDemandForm.get('email')?.updateValueAndValidity();
  }

  isValidEmail(email: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  validateEmails(): void {
    const allEmails = this.emails.concat(this.invalidEmails);
    const invalidEmails = allEmails.filter(email => !this.isValidEmail(email));
    this.invalidEmails = invalidEmails;
    this.onDemandEmailService.onDemandForm.get('email')?.setValue(
      this.invalidEmails.length > 0 ? this.invalidEmails.join(', ') : this.emails.join(', ')
    );
    this.updateFormValidity();
  }
  storeEmails(): void {
    const allEmails = this.emails.concat(this.invalidEmails);
    this.rootScopeService.activeCustTab.onDemandEmailData.emailId = allEmails.join(',');
  }


}
